import type { EditorView } from "@codemirror/view";

/** Live EditorViews by note id, for outline clicks, focus commands, etc. */
const views = new Map<string, EditorView>();
const listeners = new Set<() => void>();

export function registerEditor(noteId: string, view: EditorView): () => void {
  views.set(noteId, view);
  for (const l of listeners) l();
  return () => {
    if (views.get(noteId) === view) {
      views.delete(noteId);
      for (const l of listeners) l();
    }
  };
}

export function getEditor(noteId: string): EditorView | undefined {
  return views.get(noteId);
}

export function subscribeEditors(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
